// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont-config-user{
    width: 95%;
    position: relative;
    height: 95%;
    
}
.info-user:nth-child(odd){
    background-color: #eeeeee;
    
  }
  .info-user:nth-child(even){
    background-color: #f8f9fa;
  }
.cont-config-user  .cont-info-user{
    position: relative;
    width: 100%;
    height: 20%;
}
.cont-config-user  .cont-info-user .info-user{
    position: relative;
    width: 100%;
    height: 33%;
    display: flex;
}
.info-user .title-info-user{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
    height: 100%;
    font-size: medium;
    color: rgb(49, 49, 49);
    font-weight: bold;
}
.info-user .txt-info-user{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70%;
    height: 100%;
    font-size: medium;
    color: rgb(49, 49, 49);
}

.cont-config-user .cont-roles-user{
position: relative;
width: 100%;
height: 80%;
/* background: red; */
border-radius: 0px 0px 10px 10px;

border: #dddddd solid 2px;
border-top: unset;
}`, "",{"version":3,"sources":["webpack://./src/components/admin-components/styles/ConfigUser.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;;AAEf;AACA;IACI,yBAAyB;;EAE3B;EACA;IACE,yBAAyB;EAC3B;AACF;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;AACA,kBAAkB;AAClB,WAAW;AACX,WAAW;AACX,qBAAqB;AACrB,gCAAgC;;AAEhC,yBAAyB;AACzB,iBAAiB;AACjB","sourcesContent":[".cont-config-user{\r\n    width: 95%;\r\n    position: relative;\r\n    height: 95%;\r\n    \r\n}\r\n.info-user:nth-child(odd){\r\n    background-color: #eeeeee;\r\n    \r\n  }\r\n  .info-user:nth-child(even){\r\n    background-color: #f8f9fa;\r\n  }\r\n.cont-config-user  .cont-info-user{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 20%;\r\n}\r\n.cont-config-user  .cont-info-user .info-user{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 33%;\r\n    display: flex;\r\n}\r\n.info-user .title-info-user{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 30%;\r\n    height: 100%;\r\n    font-size: medium;\r\n    color: rgb(49, 49, 49);\r\n    font-weight: bold;\r\n}\r\n.info-user .txt-info-user{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 70%;\r\n    height: 100%;\r\n    font-size: medium;\r\n    color: rgb(49, 49, 49);\r\n}\r\n\r\n.cont-config-user .cont-roles-user{\r\nposition: relative;\r\nwidth: 100%;\r\nheight: 80%;\r\n/* background: red; */\r\nborder-radius: 0px 0px 10px 10px;\r\n\r\nborder: #dddddd solid 2px;\r\nborder-top: unset;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
